export default __webpack_public_path__ + "static/media/ser_prv_4.f3e1bc9a.png";